import React, {useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import { fetchAuthSession,getCurrentUser} from 'aws-amplify/auth';

export const ProtectedRoute = ({children}) => {
    const [signedIn,setSignedIn] = useState(false);
    const navigate = useNavigate();
  
  
  useEffect (()=> {
    // code to get the login token from cognito.
    // Construct an async callback funciton to grab username details.
    const verifyDetails = async () => {
        try {
            const { username, signInDetails } =  await getCurrentUser();
            if (signInDetails.loginId) {
                setSignedIn(true);
                return true;
            } else {
                navigate("/login")
                return false;
            }
        } catch (err) {
            navigate('/login')
            return false;
        }
    };
    const isUserVerrified = verifyDetails();
  }, [navigate]);

    return children;
};
